module.exports = __webpack_public_path__ + "img/newspic2.99f3f897.png";